import { UniDriver } from '@wix/unidriver-core';
import {
  baseUniDriverFactory,
  findByHook,
} from '../../../utils/test-utils/unidriver';
import { sectionHeaderDriverFactory } from '../../../SectionHeader/SectionHeader.uni.driver';
import { dataHooks } from '../../constants';

export const sidePanelSectionDriverFactory = (base: UniDriver) => {
  const getHeader = () =>
    sectionHeaderDriverFactory(
      findByHook(base, dataHooks.sidePanelSectionHeader),
    );

  return {
    ...baseUniDriverFactory(base),

    /** Returns title value */
    getTitle: async () => {
      const stringTitle = await base.attr('data-title');
      const nodeTitle = (await getHeader().exists())
        ? await getHeader().getTitle()
        : undefined;

      return stringTitle || nodeTitle;
    },

    /** Returns titleVisible value */
    getTitleVisible: async () => getHeader().exists(),

    /** Returns ariaLabel value */
    getAriaLabel: async () =>
      (await base.get('div[role="group"]')).attr('aria-label'),
  };
};

export type SidePanelSectionUniDriver = ReturnType<
  typeof sidePanelSectionDriverFactory
>;
